import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { json, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import config from "../../config";
import { CSVLink } from "react-csv";
import { login } from "../../features/authSlice";
import { useDispatch } from "react-redux";
import { MyContext } from "../ContextApi";

const ScanQR = ({ onSessionStarted }) => {
  const [moduleType, setModuleType] = useState("");
  const [qrcodeImage, setqrcodeImage] = useState("");
  const [token, setToken] = useState("");
  const { setEncryptedSessionItem, getDecryptedSessionItem } =
    useContext(MyContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    setToken(localStorage.getItem("Token"));

    // const url = `${sessionStorage["server"]}/pair-scanner`;
    const url = `${getDecryptedSessionItem("server")}/pair-scanner`;

    axios
      .post(
        url,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      )
      .then(({ data: response }) => {
        // console.log(response);
        if (response["status"] === "success") {
          // toast.success("successfully QR Generated");
          setqrcodeImage(response.data);
        } else {
        }
      });
  }, []);

  const onStartSession = () => {
    let sessionId;

    // const url = `${sessionStorage["server"]}/scan/start-session`;
    const url = `${getDecryptedSessionItem("server")}/scan/start-session`;

    axios
      .post(
        url,
        { module_type: "S" },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      )
      .then((response) => {
        const result = response.data;
        if (result["status"] === "success") {
          localStorage.removeItem("scannedRes");

          toast.success("successfully started session");
          sessionId = result["data"]["sessionId"];
          setqrcodeImage(null);
        } else {
          toast.error(result["error"]);
        }
      })
      .then(() => {
        // `${sessionStorage["server"]}/scan/search`,
        axios
          .post(
            `${getDecryptedSessionItem("server")}/scan/search`,

            { sessionId, module_type: "S", search_result_type: 1 },

            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("Token")}`,
              },
            }
          )
          .then((response) => {
            dispatch(login());
            // sessionStorage.setItem("request_id", response.data.data.request_id);
            // sessionStorage.setItem("session_id", sessionId);
            setEncryptedSessionItem(
              "request_id",
              response.data.data.request_id
            );
            setEncryptedSessionItem("session_id", sessionId);
            navigate("/current-scans", {
              state: response.data.data.request_id,
            });
          });
      });
  };

  return (
    <div
      className="container"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 20,
      }}
    >
      {qrcodeImage && (
        <>
          <h1 className="alignSelf-center">Scan Here</h1>
          <img
            width={300}
            height={300}
            src={`data:image/png;base64,${qrcodeImage}`}
          />
        </>
      )}
      {/* <div className="mb-3">
        <label htmlFor="">Module Type</label>
        <input
          onChange={(e) => setModuleType(e.target.value)}
          type="text"
          className="form-control"
        />
      </div> */}

      <div className="mb-3">
        <button onClick={onStartSession} className="btn btn-success">
          Start Session
        </button>
      </div>
    </div>
  );
};

export default ScanQR;
